import { type FieldError, type FieldErrors } from "react-hook-form";

import getFirstNestedFieldMessage from "./getFirstNestedFieldMessage";

export default function getFieldErrorMessage(errors: FieldErrors, name: string): string | undefined {
  const raw = errors[name];
  if (!raw) return undefined;
  if (typeof raw === "object" && raw !== null && "message" in raw && typeof (raw as FieldError).message === "string") {
    return (raw as FieldError).message;
  }
  if (Array.isArray(raw)) {
    const first = raw.find((e): e is FieldError => Boolean(e?.message));
    return first?.message;
  }
  if (typeof raw === "object") {
    return getFirstNestedFieldMessage(raw as Record<string, unknown>);
  }
  return undefined;
}
